import { createTestCaseTypes } from '../../../common/test-case/types';

export const NAMESPACE = 'analytics-test-history-vdc-test-case';
export default createTestCaseTypes(NAMESPACE);
